import CollapseSection from 'builder/components/CollapseSection'
import { formatDate } from 'builder/utils/formatDate'
import { Distribution } from 'builder/modules/resumeDistribution'
import { RecruiterList } from '../RecruiterList/RecruiterList'

interface RecruiterSectionProps {
  distributions?: Distribution[]
}

export const RecruiterSection = ({ distributions }: RecruiterSectionProps) => {
  const distributionDates = [...(distributions || [])].reverse()

  const getFormatedDate = (distribution: Distribution) => {
    const { day, month, year } = distribution || {}
    return formatDate(new Date(`${month}-${day}-${year}`), 'MMM d, yyyy')
  }

  return (
    <>
      {/* No subscription case */}
      {!distributionDates?.length ? (
        <CollapseSection
          hideExpand={true}
          hideDivider={true}
          disableHover={true}
          isExpanded={true}
          text=""
        >
          <RecruiterList distribution={{ unixFormat: 0, day: 0, month: '', year: 0 }} />
        </CollapseSection>
      ) : (
        distributionDates.map((distribution, index) => {
          const isFirstSection = index === 0
          return (
            <CollapseSection
              key={distribution.unixFormat}
              hideExpand={isFirstSection}
              hideDivider={isFirstSection}
              disableHover={isFirstSection}
              isExpanded={isFirstSection}
              text={getFormatedDate(distribution)}
            >
              <RecruiterList distribution={distribution} />
            </CollapseSection>
          )
        })
      )}
    </>
  )
}
